import { useTheme } from '@mui/material';
import React from 'react';
import { Box, IconButton, Typography } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { Theme as AugmentedTheme } from '@mui/material/styles';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  candidateNavigateBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: theme.color.background.bgField,
    color: theme.color.text.textHeader,
  },
  navigateBarLabel: {
    flex: 1,
  },
  icon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  numberNavigate: {
    color: theme.color.text.textSecondary,
  },
}));

const CandidateNavigateBar = ({
  candidateName,
  upDisabled,
  downDisabled,
  onClickUp,
  onClickDown,
  pointer,
  totalNumber,
}: {
  candidateName: string | undefined;
  upDisabled: boolean;
  downDisabled: boolean;
  onClickUp: () => void;
  onClickDown: () => void;

  pointer: number;
  totalNumber: number;
}) => {
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    (<Box className={classes.candidateNavigateBar}>
      <Box className={classes.navigateBarLabel}>
        <Typography variant="h3">{(candidateName || '').toUpperCase()}</Typography>
      </Box>
      <IconButton
        disabled={upDisabled}
        name={IconName.arrowUp}
        ariaLabel="arrow-up-icon"
        color={upDisabled ? theme.color.icon.iconDisabled : theme.color.link.linkDefault01}
        onClick={onClickUp}
        iconSize="L" />
      <Typography variant="caption" className={classes.numberNavigate}>
        {`${pointer} of ${totalNumber}`}
      </Typography>
      <IconButton
        disabled={downDisabled}
        name={IconName.arrowDown}
        ariaLabel="arrow-down-icon"
        color={downDisabled ? theme.color.icon.iconDisabled : theme.color.link.linkDefault01}
        onClick={onClickDown}
        iconSize="L" />
    </Box>)
  );
};

export default CandidateNavigateBar;
